import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../../common';
import {
  summaryWrapperStyles,
  bodyStyles,
  contentStyles,
  bottomSectionStyles,
} from './withdrawalSummaryContentStyles';

const navBarSkeletonStyles = css({
  display: 'flex',
  minHeight: '48px',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 'medium',
});

export const WithdrawalSummarySkeleton = () => (
  <div
    data-testid="withdrawal-summary-skeleton"
    className={summaryWrapperStyles}
  >
    <div className={navBarSkeletonStyles}>
      <SkeletonElement width="24px" height="24px" borderRadius="50%" />

      <SkeletonElement width="80px" height="18px" />

      <SkeletonElement width="24px" height="24px" borderRadius="50%" />
    </div>

    <div className={bodyStyles}>
      <div className={contentStyles}>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'extra_small_2',
          })}
        >
          <div
            className={css({
              display: 'flex',
              alignItems: 'center',
              gap: 'small',
              mb: 'small',
            })}
          >
            <SkeletonElement width="56px" height="56px" borderRadius="50%" />

            <SkeletonElement width="24px" height="24px" />

            <SkeletonElement width="56px" height="56px" borderRadius="50%" />
          </div>

          <SkeletonElement width="160px" height="46px" />

          <SkeletonElement width="120px" height="19px" />
        </div>

        <SkeletonElement width="100%" height="52px" borderRadius="8px" />
      </div>

      <div className={bottomSectionStyles}>
        <SkeletonElement
          width="160px"
          height="16px"
          className={css({ alignSelf: 'center' })}
        />

        <SkeletonElement width="100%" height="56px" borderRadius="4px" />
      </div>
    </div>
  </div>
);
